import { useSyncExternalStore } from 'react';
import { MatrixOnlineState, matrixStatusStore } from '../stores/MatrixStatusStore';

/**
 * Hook zum Abrufen des Online-Status des Matrix Clients.
 * Reaktiv - löst Re-Renders aus, wenn sich der Online-Status ändert.
 *
 * @returns true wenn der Client eingeloggt und initial synchronisiert ist
 */
export function useMatrixStatus(): MatrixOnlineState {
  return useSyncExternalStore(matrixStatusStore.subscribe, matrixStatusStore.getSnapshot);
}
